import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "transparent", // Color inicial
    padding: "10px 20px",
    zIndex: 1000,
    transition: "background-color 0.3s ease",
  },
  burger: {
    "@media (min-width: 1024px)": {
      display: 'none'
    },
  },
  burgerIcon: {
    color: 'white',
  },
  scrolledHeader: {
    backgroundColor: "#ffffff", // Color al hacer scroll
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Sombra opcional
  },
  images: {
    marginTop: '5px',
    marginLeft: "15%",
    display: "flex",
    alignItems: "center",
    gap: "50%",
    "@media (max-width: 1280px)": {
      marginLeft: "10%",
    },
    "@media (max-width: 768px)": {
      gap: "10px",
      marginLeft: "5%",
    },
  },
  buttonsDiv: {
    display: "flex",
    gap: "20px",
    marginRight: "15%",
    "@media (max-width: 1280px)": {
      marginRight: "10%",
    },
    "@media (max-width: 1023px)": {
      display: 'none'
    },
  },
  buttons: {
    outline: "transparent",
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      color: "#C4E9F1",
      backgroundColor: "transparent",
    },
  },
  content: {
    paddingTop: "70px",
  },
  imgLogos: {
    maxWidth: '245px'
  }
});

export default useStyles;
